import useReduxAction from '@hooks/useReduxAction'
import useSelector from '@hooks/useSelector'

import type { ModuleState } from '@redux/modules/types'

type FlipperSettingsFilters = {
  name?: string,
}

type useFlipperKeyOptions = {
  filters?: FlipperSettingsFilters,
  performHttpRequests?: boolean,
}

function useFlipperKey(key: string, options?: useFlipperKeyOptions) {
  const { performHttpRequests = true } = options || {}

  const entityReducer = useSelector(reduxState => reduxState.flipperSettings)
  const { loading: flipperSettingsLoading, result: flipperSettings } = entityReducer

  const flipperFeature = flipperSettings[key]

  useReduxAction(
    'flipperSettings',
    'loadFlipperSettings',
    {},
    [performHttpRequests],
    {
      shouldPerformFn: ({ loading }: ModuleState) => performHttpRequests && !loading,
      skipLoadedForKeysCheck: true,
    },
  )

  return {
    flipperSettings,
    isEnabled: flipperFeature?.enabled,
    loading: flipperSettingsLoading,
  }
}

export default useFlipperKey
